<template>
  <div>
    <CustomDialog
      :show="show"
      :title="$t('public.selectG')"
      @toggleShow="handleClose"
      :appendToBody="true"
      width="500"
    >
      <div slot="main">
        <div class="group" ref="group" @scroll="handleScroll">
          <div
            v-for="item in groups"
            :key="item.groupId"
            @click="select(item)"
            :style="{
              backgroundColor: selectId == item.groupId ? '#539D56' : '#FFF',
              color: selectId == item.groupId ? '#FFF' : '#000',
            }"
          >
            {{ item.groupName }}
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="btns">
          <el-button
            @click="confirm"
            type="primary"
            size="small"
            style="width: 100%"
            >{{ $t("public.submit") }}</el-button
          >
          <el-button @click="handleClose" size="small" style="width: 100%">{{
            $t("public.cancel")
          }}</el-button>
        </div>
      </div>
    </CustomDialog>
  </div>
</template>

<script>
import { deleteStaGroup } from "@/api/index.js";
import CustomDialog from "../../../components/public/customDialog";
export default {
  name: "OverseasStationManageViewList",
  components: {
    CustomDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    nextShow: {
      type: Boolean,
      default: false,
    },
    rowInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "view",
    },
    groups: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      selectInfo: {},
      selectId: 0,
      list: [],
    };
  },

  mounted() {},
  watch: {
    type: {
      handler(newV, oldV) {},
    },
  },
  methods: {
    handleScroll() {
      const container = this.$refs.group;
      const scrollHeight = container.scrollHeight;
      const scrollTop = container.scrollTop;
      const clientHeight = container.clientHeight;
      if (scrollTop + clientHeight >= scrollHeight && !this.loading) {
        // this.loadMore()
        console.log("到底了");
      }
    },
    select(e) {
      this.selectInfo = e;
      this.selectId = e.groupId;
      console.log(e, "eeeee");
    },
    confirm() {
      if (!this.selectId) {
        // this.$message.warning("请选择基站组")
        this.$message.warning(this.$t("public.p8"));
        return;
      }
      if (this.type !== "delGroup") {
        // 编辑基站组
        this.selectId = null;
        console.log(this.selectInfo, "this.selectInfo")
        this.$emit("update:name", this.selectInfo.groupName); // 传递基站组名称
        this.$emit("update:selectGroup", this.selectInfo); // 传递基站组信息
        // this.$emit('selectValue')
        this.handleClose();
        this.$emit("update:nextShow", true);
      } else {
        // 删除基站组
        // this.selectId = null;
        let param = {
          groupId: this.selectInfo.groupId
        };
        // console.log(this.selectId, "选中");
        deleteStaGroup(param).then((res) => {
          if(res.code == 200){
            this.$emit("refush")
            this.handleClose();
            this.$message.success(this.$t("public.success3"))
          }
        });
      }
    },
    handleClose() {
      this.$emit("update:show", false);
      this.$emit("update:rowInfo", {});
      this.selectInfo = {};
      this.selectId = "";
      this.$emit("update:type", "")
    },
  },
};
</script>
<style lang="scss" scoped>
.btns {
  display: flex;
  justify-content: center;
  align-items: center;
}
.group {
  padding: 10px;
  max-height: 300px;
  margin-left: 10px;
  overflow: auto;
  div {
    padding: 5px;
  }
}
</style>
